import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-14 dark:bg-dark-300 bg-gray-100 dark:shadow-none shadow-md sm:hidden flex justify-between border-t dark:border-gray-600" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "flex h-full w-full" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex items-center justify-center w-full dark:hover:text-primary-100 hover:text-white hover:opacity-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      modelValue: _ctx.showModalLogout,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModalLogout) = $event))
    }, {
      header: _withCtx(() => [
        _createTextVNode("Вы уверены, что хотите выйти?")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_button, {
            class: "flex-4",
            theme: "passive",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalLogout = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Отмена")
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, {
            class: "flex-2",
            onClick: $options.logout
          }, {
            default: _withCtx(() => [
              _createTextVNode("Да")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (l) => {
        return (_openBlock(), _createElementBlock("li", {
          key: l.name,
          class: "flex flex-1 cursor-pointer items-center justify-center"
        }, [
          _createElementVNode("div", {
            class: "w-full h-full flex items-center dark:hover:text-primary-100 hover:text-white hover:opacity-100",
            onClick: ($event: any) => ($options.onClick(l))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("i", {
                class: _normalizeClass(["transition-colors text-lg", {
                        [l.icon]: true,
                        'dark:text-white text-gray-700 dark:opacity-100 ': l.name != _ctx.$route.name,  
                        'dark:text-primary-100 text-primary-300 opacity-100 text-white': l.name == _ctx.$route.name
                    }])
              }, null, 2)
            ])
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}